import { call, put, takeEvery, select, delay } from 'redux-saga/effects';
import workflowActions from './actions';
import { wrapPageSagaWithErrorHandler } from '../page/sagas';

function* startWorkflow() {
  let request;
  let searchParamsState;
  const jscEnabled = yield select((state) => state.session.meta.configs.jsc_enabled);
  if (jscEnabled) {
    yield delay(500);
    const deviceToken = yield select((state) => state.ui.deviceToken);
    ({ request, searchParamsState } = workflowActions.getRequest(deviceToken));
  } else {
    ({ request, searchParamsState } = workflowActions.getRequest());
  }

  const response = yield call(request);
  const { data } = response;
  yield put(workflowActions.startSuccess(data, searchParamsState));
}

function* restartWorkflow({ payload }) {
  try {
    const request = workflowActions.getRestartRequest(payload);
    const response = yield call(request);
    const { data } = response;
    yield put(workflowActions.restartSuccess(data));
  } catch (e) {
    if (payload.errorHandler) {
      yield put(payload.errorHandler);
      yield put(workflowActions.restartFailed(e));
    } else {
      /** just let the default handle it */
      throw e;
    }
  }
}

export default [
  takeEvery(workflowActions.START, wrapPageSagaWithErrorHandler(startWorkflow)),
  takeEvery(workflowActions.RESTART, wrapPageSagaWithErrorHandler(restartWorkflow)),
];
